"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.from = undefined;

var _FromObservable = require("./FromObservable");

var from = exports.from = _FromObservable.FromObservable.create;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/observable/from.js
// module id = 217
// module chunks = 0